import { create } from 'zustand';

export type EditorSpec =
  { kind: 'status'; spaceId?: string; listId?: string } | { kind: 'tags'; spaceId: string };

export const useEditors = create<{ spec: EditorSpec | null; set: (s: EditorSpec | null) => void }>(
  (set) => ({
    spec: null,
    set: (spec) => set({ spec }),
  }),
);

export const openStatusEditor = (scope: { spaceId?: string; listId?: string }) =>
  useEditors.getState().set({ kind: 'status', ...scope });
export const openTagsEditor = (spaceId: string) =>
  useEditors.getState().set({ kind: 'tags', spaceId });
